<template>
  <div class="comp1-container">
    <!-- content -->
    <div class="comp1-content" ref="resultContent">
      <!-- result wheel -->
      <div class="results-wheels-container">
        <div class="results-wheels">
          <div v-for="phase in filteredPhases" :key="phase.code" class="results-wheels-wheel-container">
            <p class="results-wheels-wheel-title">{{phase.code}}: {{phase.name}}</p>
            <p class="results-wheels-wheel-text">{{$t('global.wheelZoom')}}</p>
            <div @click="showWheelInModal(phase.index)">
              <result-wheel ref="resultWheel" class="results-wheels-wheel" :phaseIndex="phase.index"></result-wheel>
            </div>
          </div>
        </div>
      </div>

      <div v-if="listViewHistory !== 'wheelsHistory'" class="results-details">
        <div v-for="phase in filteredPhases" :key="phase.code" class="results-details-phase-container">
          <div class="results-details-phase">
            <h3>{{phase.code}}: {{phase.name}}</h3>
          </div>

          <!-- goals -->
          <template v-if="phaseGoals(phase.index, true).length > 0">
            <div v-for="goal in phaseGoals(phase.index, true)" :key="goal.code" class="results-details-goal-container">
              <div class="results-details-goal">
                <icon :name="goal.code" class="results-details-goal-icon"></icon>
                <h4>{{goal.code}}: {{profileGoal(goal.code).title}}</h4>
              </div>

              <!-- targets -->
              <div class="results-details-targets">
                <div v-for="target in profileGoalTargets(phase.index, goal.code)" :key="target.code" class="results-details-target">
                  <icon class="results-details-target-bullet" :class="['target-bullet-color-' + goal.code]" name="bullet"></icon>
                  <div class="tasks-content-targets-list-item-text">{{target.description}}</div>
                </div>
              </div>

              <!-- tasks -->
              <div v-if="goal.tasks.filter(task => task.selected || task.custom).length > 0" class="results-details-tasks">
                <div v-for="task in goal.tasks.filter(task => task.selected || task.custom)" :key="task.code" class="results-details-task">
                  <div class="results-details-task-header">
                    <icon class="results-details-task-header-icon" :class="['task-color-' + goal.code, {'task-selected': (task.how.trim() !== '' && task.what.trim() !== '') || task.custom}, {'task-notcustom': !task.custom}]" :task="true" :phaseCode="phase.code" :taskCode="task.code" :name="goal.code"></icon>
                    <div class="results-details-task-header-text">
                      <div class="results-details-task-header-title">{{task.title}}</div>
                      <div class="results-details-task-header-description" v-html="task.description"></div>
                    </div>
                  </div>

                  <div class="results-details-task-data">
                    <div class="results-details-task-data-what">
                      <div class="results-details-task-data-label">{{$t('results.whatLabel')}}</div>
                      <div class="results-details-task-data-text">{{task.what}}</div>
                    </div>
                    <div class="results-details-task-data-how">
                      <div class="results-details-task-data-label">{{$t('results.howLabel')}}</div>
                      <div class="results-details-task-data-text">{{task.how}}</div>
                    </div>
                    <div class="results-details-task-data-completedpct">
                      <div class="results-details-task-data-label">{{$t('results.completedPctLabel')}}</div>
                      <div class="results-details-task-data-completedpct">
                        <completed-percent class="results-details-task-data-completedpct-slider" :percent="task.completedPct" :negative="task.negative" :color="goal.code"></completed-percent>
                        <div class="results-details-task-data-completedpct-value"><span v-if="task.negative">(</span>{{task.completedPct}}%<span v-if="task.negative">)</span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div v-else class="results-details-phase-nogoals">{{$t('results.noGoals')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import resultWheel from './../shared/result-wheel/result-wheel'
import completedPercent from './../shared/completed-percent/completed-percent'

export default {
  name: 'resultHistory',
  props: {
    showFilters: {
      type: Boolean,
      required: true
    },
    activeComponent: {
      type: String,
      required: true
    },
    setScroll: {
      type: Date
    },
    listViewHistory: {
      type: String,
      required: true
    }
  },
  components: {
    resultWheel,
    completedPercent
  },
  computed: {
    ...mapGetters({
      project: 'getProject',
      createPDF: 'getCreatePDF',
      phaseGoals: 'getPhaseGoals',
      profileGoal: 'getProfileGoal',
      projectPhases: 'getProjectPhases',
      activePhaseIndex: 'getActivePhaseIndex',
      activePhaseIndexes: 'getActivePhaseIndexes',
      profileGoalTargets: 'getProfileGoalTargets'
    }),
    filteredPhases () {
      let phases = []
      for (let i = 0; i < this.projectPhases.length; i++) {
        if (this.activePhaseIndexes.includes(i)) {
          phases.push(this.projectPhases[i])
        }
      }
      return phases
    }
  },
  methods: {
    ...mapActions({
      setPDF: 'setPDF',
      setCreatePDF: 'setCreatePDF',
      setShowModal: 'setShowModal',
      setModalType: 'setModalType',
      setModalData: 'setModalData',
      setActivePageCode: 'setActivePageCode'
    }),
    showWheelInModal (phaseIndex) {
      this.setShowModal(true)
      this.setModalType('result-wheel-modal')
      this.setModalData(phaseIndex)
    }
  },
  watch: {
    async createPDF (val, oldVal) {
      if (val && this.activeComponent === 'resultLatest') {
        this.setCreatePDF(false)
        this.setShowModal(true)
        this.setModalType('create-pdf-modal')

        try {
          let pdfObject = {
            profileId: this.project.profileId,
            projectJson: '',
            baseUrl: window.location.href,
            resultWheels: [],
            filter: JSON.stringify({
              showOnlyWheels: this.listViewHistory === 'wheelsHistory'
            })
          }
          this.$refs.resultWheel.forEach(wheel => {
            pdfObject.resultWheels.push(wheel.jsWheel.getSvgText())
          })
          await this.setPDF(pdfObject)
          this.setShowModal(false)
          this.setModalType(null)
        } catch (err) {
          console.log('error creating PDF', err)
          this.setCreatePDF(false)
        }
      }
    },
    setScroll (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.resultContent.scrollTop = 0
        })
      }
    }
  }
}
</script>
